export default {"src":"/_next/static/media/insurance-plan.143b156d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};